import { CLICKME_SIGNIFICANT_DEBT_THRESHOLD } from 'utils/constants/balance';

/**
 * Нужно ли показывать пользователю состояние «Нужно пополнить»:
 * - доступный баланс ≤ CLICKME_SIGNIFICANT_DEBT_THRESHOLD → всегда показываем
 * - CLICKME_SIGNIFICANT_DEBT_THRESHOLD < availableBalance < 0 → показываем только если
 *   есть кампании, остановленные из-за исчерпания баланса счёта
 * - availableBalance ≥ 0 → не показываем
 */
export const isNeedTopUp = (availableBalance: number, existStoppedCampaign: boolean): boolean => {
    if (availableBalance >= 0) {
        return false;
    }
    if (availableBalance <= CLICKME_SIGNIFICANT_DEBT_THRESHOLD) {
        return true;
    }
    return existStoppedCampaign;
};
